import { noop } from 'lodash';
import { useIntl } from 'react-intl';
import { Selector } from 'sonata-react-components';

import { AgencyGroupSelectorstyled } from '../AgencyGroupSelectors.styled';

function AgencyGroupSelectorsSkeleton() {
  const { formatMessage } = useIntl();

  return (
    <AgencyGroupSelectorstyled>
      <Selector
        className="advertiserCampaignSelector__agencySelector"
        isDisabled
        label={formatMessage({
          defaultMessage: 'Agency',
          id: 'advertisers.form.agency.label'
        })}
        onChange={noop}
        options={[]}
        showSearch
        type="simple"
        value={[]}
      />
      <Selector
        className="advertiserCampaignSelector__groupSelector"
        isDisabled
        label={formatMessage({
          defaultMessage: 'Group',
          id: 'advertisers.form.group.label'
        })}
        onChange={noop}
        options={[]}
        showSearch
        type="simple"
        value={[]}
      />
    </AgencyGroupSelectorstyled>
  );
}

export default AgencyGroupSelectorsSkeleton;
